import { useCommonData } from '@udemy-v2/common-data';
export const useUserHasOrganization = () => {
  const commonData = useCommonData();
  return !!commonData?.organization;
};